<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="120px" >
          <el-row>
            <el-col :span="9">
              <el-form-item :label="$t('field.demandDate')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="FAE">
                <el-select v-model="fae" :placeholder="$t('msg.pleaseSelect')" >
                  <el-option v-for="item in faeOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$t('field.expandbySerialNo')" label-width="200px">
                <el-switch v-model="expandBySn"></el-switch>
              </el-form-item>
            </el-col>    
            <el-col :span="5" v-if="!expandBySn">
              <el-form-item :label="$t('field.showPersonalTasks')" label-width="180spx">
                <el-switch v-model="showPersonalTasks"></el-switch>
              </el-form-item>
            </el-col>    
          </el-row> 
          <el-row>
            <!--<el-col :span="12">
              <el-form-item :label="$t('field.docNo')">
                <el-input v-model="requestNo"></el-input>
              </el-form-item>
            </el-col>-->
          
          </el-row>   
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
            </el-col>             
          </el-row>   
        </el-form>
        <el-row>  
          <Table  v-if="!expandBySn" ref="table1" :tableData="tableData" :linkAction="linkAction" @reload-data-by-sort="reloadDataBySort"/> 
          <Table  v-else ref="table2" :tableData="tableData2" :linkAction="linkAction" @reload-data-by-sort="reloadDataBySort"/> 
        </el-row>
        
    </el-main>
  </div>
</template>

<script>
import Table from '../components/FuzzySearchTableWithRemoteSort'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindCustIncxWindowsForFae, apiFindFeedbackList } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";

  
export default {
  name: 'customerFeedbackHandling',
  data() {    
    return {       
      expandBySn:false,
      showPersonalTasks:false,
      sdate: '',
      edate: '',
      requestNo: '',
      sortColumn:'',
      sortType:'',
      fae: '',
      faeOpts:[],
      tableData: {
        columns: [
          { field: "requestNo", title: this.$i18n.t('field.docNo'), width: 160, link:true, align:'center', width:180 },         
          { field: "status", title:  this.$i18n.t('field.status'), width:100  },
          { field: "applyAccount", title: this.$i18n.t('field.requestAccount'), width: 200  },  
          { field: "applyDate", title: this.$i18n.t('field.demandDate') , width: 150   },
          { field: "customerShortName", title: this.$i18n.t('field.sortl'), width: 220 },
         // { field: "installationDate", title: this.$i18n.t('field.installedTime'), width: 150 },
         // { field: "sn", title: this.$i18n.t('field.serialNo'), width: 180 },       
          { field: "symptom", title: this.$i18n.t('field.symptom'), width: 400 },
          { field: "fae", title: 'INCX FAE',align:'center', width: 140 },
          { field: "rmaNo", title: 'RMA Number', align:'center', width: 170 },
          { field: "resp", title: this.$i18n.t('field.judgmentofLiability'), align:'center', width: 200 },
          { field: "assignee", title: this.$i18n.t('field.taskOwner'), align:'center', width: 140 }
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'custTable',
        exportName: this.$i18n.t('menu.customerFeedbackHandling')
      },
      tableData2: {
        columns: [
          { field: "requestNo", title: this.$i18n.t('field.docNo'), width: 160, link:true, align:'center', width:180 },         
          { field: "status", title: this.$i18n.t('field.status'), width:100  },
          { field: "applyAccount", title: this.$i18n.t('field.requestAccount'), width: 200  },  
          { field: "applyDate", title: this.$i18n.t('field.demandDate') , width: 150   },
          { field: "customerShortName", title: this.$i18n.t('field.sortl'), width: 220 },
          { field: "fae", title:'INCX FAE', width: 180 },    
          { field: "productType", title: this.$i18n.t('field.productType'), width: 150 },   
          { field: "sn", title: this.$i18n.t('field.serialNo'), width: 300 },
          { field: "symptom", title: this.$i18n.t('field.symptom'), width: 300 },
          { field: "installationDate", title: this.$i18n.t('field.installedTime'), align:'center', width: 145 },
          { field: "shippingDate", title: this.$i18n.t('field.shippingDate'), align:'center', width: 145 },
          { field: "model", title: this.$i18n.t('field.model'), width: 135 },
          { field: "modelName", title: this.$i18n.t('field.modelName'), width: 135 },
          { field: "goodType", title: this.$i18n.t('field.rmaGoodsType'), width: 170 },
          { field: "rmaNo", title: 'RMA Number', width: 150 },
          { field: "defectCode", title: 'Defect Code', width: 150  },
          { field: "level1", title: 'Level1', width: 150  },
          { field: "level2", title: 'Level2', width: 150  },
          { field: "level3", title: 'Level3', width: 150  },
          { field: "resp", title:this.$i18n.t('field.judgmentofLiability'), width: 200  },
          { field: "hardwareRepairPart", title: this.$i18n.t('field.hardwareRepairPart'), width: 200  },
          { field: "purpose", title:  this.$i18n.t('field.softwareUpgrade'), width: 200  },
          { field: "mesShippingDate", title:  this.$i18n.t('field.mesShippingDate'), width: 180  },
          { field: "productId", title:'Product ID', width: 180  },
          { field: "panelId", title: 'Panel ID', width: 180  },
          { field: "dn", title:'Related DN', width: 180  },
          { field: "panelReceivedDate", title:  this.$i18n.t('field.panelReceivedDate'), width: 190  },
          { field: "vrifiedDate", title:  this.$i18n.t('field.vrifiedDate'), width: 180  },
          { field: "reportDate", title:  this.$i18n.t('field.reportDate'), width: 180  },
          { field: "issueInfo", title:  this.$i18n.t('field.caseType'), width: 200  },
          { field: "faeProposalDate", title:  this.$i18n.t('field.faeProposalDay'), width: 180  }
         
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'custTable',
        exportName: this.$i18n.t('menu.customerFeedbackHandling')
      }     
    };
  }, 
  components: {
    Breadcrumb,
    Table
  },
  mounted() {  

    apiFindCustIncxWindowsForFae({ headers: authHeader()}).then((response) => { 
      this.faeOpts = [];
      response.data.forEach((item, index) => {   
        this.faeOpts.push({ value: item.value, label: item.value  });
      });
    }).catch((err) => {
      console.log(err);
    });
    this.findData()
   
  },
  watch:{
    expandBySn(){
      this.findData();            
    }
  },
  methods: {
    findData(){      
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
      }
       if(this.edate != null && this.edate != ''){        
        edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
      }
      
      apiFindFeedbackList({ headers: authHeader(), sdate : sdate, edate : edate, fae: this.fae, bySn:this.expandBySn, no: this.requestNo, 
                            showPersonalTasks:this.showPersonalTasks, sortColumn: this.sortColumn, sortType:this.sortType}).then((response) => { 

       if(this.expandBySn){
          response.data.forEach((item, index) => {   
            item.installationDate = item.installationDate.substring(0,10);
            item.shippingDate = item.shippingDate.substring(0,10);
          });             
          this.tableData2.data = response.data;  
          this.tableData2.originalTableData =  this.tableData2.data;
          this.$refs.table2.$refs.filterTable.doLayout();
        }else{      
          this.tableData.data = response.data;  
          this.tableData.originalTableData =  this.tableData.data;  
          this.$refs.table1.$refs.filterTable.doLayout();
        }
            
      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData();
    },   
    linkAction(row, index){    
      //this.$router.push("/ProcessFeedback/" + row.feedbackId);
      const { href } = this.$router.resolve("/ProcessFeedback/" + row.feedbackId );
      window.open(href, '_blank');
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      debugger
      this.findData()
    }     
  }
};
</script>
